import React, { forwardRef } from 'react';
import {
  EVTextField,
  EVInputLabel,
  EVGrid,
  EVFormHelperText,
} from '@eagleview/ev-comp-library';
import PropTypes from 'prop-types';
import useStyles from './PhoneInputFieldStyle';

const PhoneInputField = forwardRef((props, ref) => {
  const classes = useStyles();
  const {
    labelText, inputId, inputValue: { countryId, number, ext }, isRequired, handleChange, errorMessage, handleBlur, isDisabled,
  } = props;

  const handleInputChange = (event) => {
    const { target: { id, value } } = event;
    if (id === inputId && !Number.isNaN(Number(value)) && value.length <= 10) {
      const phoneEvent = {
        ...event,
        target: {
          id,
          value: {
            countryId,
            number: value,
            ext,
          },
        },
      };
      handleChange(phoneEvent);
    }
    if (id === 'ext') {
      handleChange({
        ...event,
        target: {
          id: 'phone',
          value: {
            countryId,
            number,
            ext: value,
          },
        },
      });
    }
  };
  const extId = `ext${inputId}`;
  return (
    <EVGrid container style={{ flexDirection: 'row', gap: '16px' }}>
      <EVGrid className={classes.phoneContainer}>
        <EVInputLabel
          className={classes.label}
          required={isRequired}
          classes={{ asterisk: classes.asterisk }}
          error={errorMessage.length > 0}
          htmlFor={inputId}
        >
          {labelText}
        </EVInputLabel>
        <EVTextField
          id={inputId}
          value={number}
          variant="outlined"
          fullWidth
          size="small"
          style={{ flex: 1 }}
          error={errorMessage.length > 0}
          onChange={handleInputChange}
          onBlur={handleBlur}
          classes={{ root: classes.phoneInput }}
          disabled={isDisabled}
          type="tel"
          inputRef={ref}
        />
        <EVFormHelperText className={classes.error}>{errorMessage}</EVFormHelperText>
      </EVGrid>
      <EVGrid className={classes.extContainer}>
        <EVInputLabel
          className={classes.label}
          htmlFor={extId}
        >
          Ext.
        </EVInputLabel>
        <EVTextField
          id={extId}
          value={ext}
          variant="outlined"
          fullWidth
          size="small"
          onChange={handleInputChange}
          InputProps={{
            className: classes.extInput,
          }}
          disabled={isDisabled}
        />
      </EVGrid>
    </EVGrid>
  );
});

PhoneInputField.propTypes = {
  /**
   * @property {string} labelText - Text to be used as label
   */
  labelText: PropTypes.string,
  /**
   * @property {string} inputId - Id of EVTextField
   */
  inputId: PropTypes.string.isRequired,
  /**
   * @property {number} inputValue - Value of EVTextField
   */
  inputValue: PropTypes.shape(),
  /**
   * @property {Function} handleChange - Function to handle change in input value in EVTextField
   */
  handleChange: PropTypes.func.isRequired,
  /**
   * @property {Function} handleBlur - Function to handle blur in input value in EVTextField
   */
  handleBlur: PropTypes.func,
  /**
   * @property {string} errorMessage - Error message to be displayed by helper text
   */
  errorMessage: PropTypes.string,
  /**
  * @property {bool} isDisabled - boolean value to disable the component
   */
  isDisabled: PropTypes.bool,
  /**
  * @property {bool} isRequired - isRequired for component
   */
  isRequired: PropTypes.bool,
};

PhoneInputField.defaultProps = {
  labelText: '',
  inputValue: '',
  isDisabled: false,
  isRequired: false,
  errorMessage: '',
  handleBlur: () => {
    //
  },
};

export default PhoneInputField;
